export default {"src":"/_next/static/media/cards-icon-1.d9ec909d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};